export default {
  login: {
    title: 'تسجيل الدخول',
    usernameLabel: 'اسم المستخدم',
    usernamePlaceholder: '2-10 أحرف تبدأ بحرف وتحتوي على أرقام وحروف',
    loginPasswordLabel: 'كلمة المرور',
    loginPasswordPlaceholder: 'يرجى إدخال كلمة المرور',
    googleCodeLabel: 'رمز Google',
    googleCodePlaceholder: 'يرجى إدخال رمز Google المكون من 6 أرقام',
    hasNoAccount: 'لا تملك حسابًا،',
    goRegister: 'اذهب للتسجيل',
    onlineCustom: 'دعم العملاء',
    loginArgument: 'بالاستمرار في تسجيل الدخول، فإنك توافق على',
    userArgument: 'اتفاقية المستخدم',
    registerNotEnabled: 'التسجيل غير مفتوح، يرجى الاتصال بالإدارة',
    usernameRequired: 'يرجى إدخال اسم المستخدم الصحيح',
    loginPasswordRequired: 'يرجى إدخال كلمة المرور الصحيحة',
    googleCodeRequired: 'يرجى إدخال رمز Google الصحيح',
    loginButton: 'تسجيل الدخول'
  },
  register: {
    title: 'تسجيل',
    usernameLabel: 'اسم المستخدم',
    usernamePlaceholder: 'يرجى إدخال اسم المستخدم للتسجيل',
    loginPasswordLabel: 'كلمة المرور',
    loginPasswordPlaceholder: 'يرجى إدخال كلمة مرور المستخدم للتسجيل',
    loginPasswordPreLabel: 'تأكيد كلمة المرور',
    loginPasswordPrePlaceholder: 'يرجى إدخال كلمة المرور مرة أخرى',
    fudPasswordLabel: 'كلمة مرور الأموال',
    fudPasswordPlaceholder: 'يرجى إدخال كلمة مرور الأموال',
    inviteCodeLabel: 'كود الدعوة',
    inviteCodePlaceholder: 'يرجى إدخال كود الدعوة المكون من 6 أرقام',
    registerNeed: 'بالاستمرار في التسجيل، فإنك توافق على',
    registerArgument: 'اتفاقية التسجيل',
    usernameRequired: 'يرجى إدخال اسم المستخدم الصحيح',
    loginPasswordRequired: 'يرجى إدخال كلمة المرور الصحيحة',
    loginPasswordPreRequired: 'يرجى إدخال كلمة المرور لتأكيد التسجيل',
    fundPasswordRequired: 'يرجى إدخال كلمة مرور الأموال الصحيحة',
    inviteCodeRequired: 'يرجى إدخال كود الدعوة الصحيح',
    diffLoginPasswordError: 'كلمتا المرور المدخلتان غير متطابقتين',
    registerSuccess: 'تم التسجيل بنجاح',
    registerButton: 'تسجيل',
    emailLabel: 'البريد الإلكتروني',
    emailPlaceholder: 'يرجى إدخال عنوان البريد الإلكتروني',
    emailCodeLabel: 'رمز البريد الإلكتروني',
    emailCodePlaceholder: 'يرجى إدخال رمز البريد الإلكتروني',
    second: 'ثانية',
    getEmailCodeButton: 'الحصول على رمز التحقق',
    emailRequired: 'يرجى إدخال عنوان البريد الإلكتروني الصحيح وإعادة المحاولة',
    emailCodeRequired: 'يرجى إدخال رمز البريد الإلكتروني الصحيح وإعادة المحاولة'
  },
  home: {
    hotCoin: {
      title: 'التداولات الساخنة',
      more: 'المزيد'
    },
    poster: {
      title: 'الشحن السريع',
      enter: 'دخول فوري>',
      subTitle: 'يدعم BTC، USDT، ETH، وغيرها'
    },
    quickMenus: {
      futuresTrading: 'تداول العقود الآجلة',
      helpCenter: 'مركز المساعدة'
    },
    ranking: {
      increase: {
        title: 'الأكثر ارتفاعًا'
      },
      clinch: {
        title: 'الأعلى حجمًا'
      }
    }
  },
  tabBar: {
    home: 'الرئيسية',
    price: 'الأسعار',
    trade: 'التداول',
    fund: 'الأصول',
    user: 'حسابي'
  },
  currency: {
    favorite: 'المفضلة',
    allCurrency: 'جميع العملات',
    dayVol: 'حجم 24 ساعة',
    addFavor: '+ إضافة إلى المفضلة'
  },
  trade: {
    bills: 'الفواتير',
    todayOpen: 'الافتتاح اليوم',
    star: 'المفضلة',
    vol: 'حجم التداول',
    low: 'الأدنى',
    high: 'الأعلى',
    timing: 'التوقيت',
    spot: 'الفوري',
    buyMore: 'شراء المزيد',
    buyEmpty: 'بيع',
    indicator: 'المؤشر',
    indicatorSettings: 'إعدادات المؤشر',
    balance: 'رصيدي',
    fee: 'الرسوم',
    ruleIdError: 'يرجى اختيار وقت الانتهاء',
    deleteFavoriteSuccess: 'تم حذف العملة المفضلة بنجاح',
    addFavoriteSuccess: 'تم إضافة العملة المفضلة بنجاح',
    buyIn: 'شراء',
    sellOut: 'بيع',
    holding: 'الاحتفاظ',
    history: 'السجل',
    spotOrderConfirm: {
      title: 'تأكيد الشراء',
      amountPlaceholder: 'يرجى إدخال كمية الشراء'
    },
    spotTradeOrder: {
      holding: {
        coin: 'العملة',
        buyInAmountPrice: 'إجمالي السعر / السعر الفردي',
        buyInCount: 'الكمية',
        actions: 'الإجراءات',
        sellOut: 'بيع',
        profit: 'الربح والخسارة'
      }
    },
    orderConfirm: {
      title: 'تأكيد الطلب',
      coinName: 'العملة',
      direction: 'الاتجاه',
      price: 'السعر الحالي',
      balance: 'الرصيد',
      fee: 'الرسوم',
      buyMoreLabel: 'شراء المزيد',
      buyEmptyLabel: 'بيع',
      buyQuantity: 'كمية الشراء',
      buyAmount: 'مبلغ الشراء',
      submit: 'تأكيد الطلب'
    },
    kline: {
      open: 'فتح:',
      close: 'إغلاق:',
      change: 'التغير:'
    }
  },
  finance: {
    title: 'المالية'
  },
  allFinance: {
    title: 'التمويل',
    all: 'الكل'
  },
  financeOrders: {
    title: 'طلبات الرهن',
    holdingLabel: 'في الاحتفاظ',
    historyLabel: 'السجل',
    holding: {
      amount: 'مبلغ الرهن',
      rateStr: 'مبلغ الأرباح / نسبة الأرباح',
      vcCount: 'كمية العملة المرهونة',
      cycle: 'دورة الاحتفاظ',
      day: 'يوم',
      calcStartDate: 'تاريخ بدء الاحتساب',
      serviceAmount: 'رسوم الخدمة',
      redeemOrder: 'استرداد'
    },
    history: {
      incomeAmount: 'مبلغ الأرباح',
      rateStr: 'نسبة الأرباح',
      amount: 'مبلغ الرهن',
      vcCount: 'كمية العملة المرهونة',
      calcStartDate: 'تاريخ بدء الاحتساب',
      calcEndDate: 'تاريخ انتهاء الاحتساب',
      cycle: 'دورة الأيام',
      serviceAmount: 'رسوم الخدمة',
      day: 'يوم'
    }
  },
  financeOrderBills: {
    title: 'فواتير أرباح الرهن',
    amount: 'المبلغ',
    balance: 'الرصيد'
  },
  financeItem: {
    rateStr: 'نسبة الأرباح',
    buyType: 'نوع الشراء',
    cycle: 'دورة الأيام',
    exchangeRate: 'سعر الصرف (تحويل العملة الافتراضية إلى الرصيد)',
    day: 'يوم',
    cycleType: 'نوع الدورة',
    serviceRateStr: 'نسبة رسوم الخدمة'
  },
  buyFinance: {
    title: 'شراء',
    rateStr: 'معدل العائد',
    name: 'الاسم',
    buyType: 'نوع الشراء',
    cycle: 'عدد أيام الدورة',
    cycleType: 'نوع الدورة',
    exchangeRate: 'سعر الصرف (تبادل العملة الافتراضية مع الرصيد)',
    serviceRateStr: 'معدل الخدمة',
    remark: 'ملاحظة',
    buyAmountLabel: 'مبلغ الشراء ({coin})',
    descriptionTitle: 'وصف المنتج',
    descriptionPart1:
      '1. هذا المنتج هو منتج مالي غير مضمون، قد تؤدي تقلبات السوق إلى خسارة رأس المال، يرجى الاستثمار بحذر.',
    descriptionPart2: '2. قواعد تسوية المدفوعات:',
    descriptionPart3:
      'إذا كان سعر التسوية < السعر المرتبط، سيتم تسوية BTC عند الاستحقاق؛ كمية التسوية = مبلغ الاستثمار * (1 + عدد الأيام * معدل العائد السنوي / 365).',
    descriptionPart4:
      'إذا كان سعر التسوية ≥ السعر المرتبط، سيتم تسوية USDT عند الاستحقاق؛ كمية التسوية = مبلغ الاستثمار * السعر المرتبط * (1 + عدد الأيام * معدل العائد السنوي / 365).',
    descriptionPart5:
      '3. يتغير معدل العائد السنوي الفعلي مع تقلبات السوق في الوقت الفعلي، يرجى الاعتماد على الصفقة الفعلية.',
    descriptionPart6:
      '4. يتم تحويل مبلغ الاستثمار وفقًا لسعر السوق في الوقت الفعلي، يرجى الاعتماد على الصفقة الفعلية.',
    descriptionPart7:
      "5. يمكن عرض المبلغ المستثمر في صفحة 'حيازة العملات' الخاصة بي، بعد انتهاء الاستحقاق سيتم تحويل المدفوعات تلقائيًا إلى حساب التداول الفوري.",
    buyButton: 'شراء [{coin}]'
  },
  fund: {
    description: 'الأصول',
    recharge: 'شحن العملة',
    withdraw: 'سحب العملة',
    exchange: 'التحويل',
    empty: 'المحفظة فارغة، اذهب إلى'
  },
  userCenter: {
    lastLogin: 'آخر تسجيل دخول',
    myTeam: 'فريقي',
    identity: 'تحقق الهوية',
    walletAddress: 'عنوان المحفظة',
    zskAccount: 'حساب ZSK',
    bankCard: 'الحساب البنكي',
    userBills: 'سجل المعاملات',
    timingTradeOrder: 'حيازة سريعة',
    spotTradeOrder: 'حيازة العقود الآجلة',
    contactTradeOrder: 'حيازة العقود',
    userReport: 'تقرير المستخدم',
    teamReport: 'تقرير الفريق',
    share: 'أريد المشاركة',
    customer: 'اتصل بالدعم',
    helpCenter: 'مركز المساعدة',
    platform: 'مقدمة المنصة',
    profit: 'الربح اليومي',
    balance: 'رصيدي',
    withdraw: 'سحب العملة',
    recharge: 'شحن العملة',
    creditStoreLabel: 'النقاط الائتمانية'
  },
  settings: {
    title: 'الإعدادات',
    fundPassword: 'كلمة مرور الأموال',
    googleValidator: 'مدقق جوجل',
    editLoginPassword: 'تغيير كلمة مرور الدخول',
    switchLocale: 'تبديل اللغة'
  },
  editFundPassword: {
    title: 'تغيير كلمة مرور الأموال',
    currentPasswordLabel: 'كلمة المرور الحالية',
    currentPasswordPlaceholder: 'يرجى إدخال كلمة المرور الحالية للأموال',
    newPasswordLabel: 'كلمة المرور الجديدة',
    newPasswordPlaceholder: 'يرجى إدخال كلمة المرور الجديدة للأموال',
    prePasswordLabel: 'تأكيد كلمة المرور',
    prePasswordPlaceholder: 'يرجى إدخال كلمة المرور الجديدة مرة أخرى',
    tips:
      'كلمة مرور الأموال هي شهادة هامة للمعاملات، يرجى ضبطها بعناية وتذكرها',
    currentPasswordRequired: 'يرجى إدخال كلمة المرور الحالية للأموال',
    newPasswordRequired: 'يرجى إدخال كلمة المرور الجديدة للأموال',
    prePasswordRequired: 'يرجى إدخال كلمة المرور الجديدة مرة أخرى',
    prePasswordDiff: 'كلمتا المرور غير متطابقتين'
  },
  bindFundPassword: {
    title: 'ربط كلمة مرور الأموال',
    fundPasswordLabel: 'كلمة مرور الأموال',
    fundPasswordPlaceholder: 'يرجى إدخال كلمة مرور الأموال',
    fundPasswordPreLabel: 'تأكيد كلمة المرور',
    fundPasswordPrePlaceholder: 'يرجى إدخال كلمة مرور الأموال مرة أخرى',
    fundPasswordRequired: 'يرجى إدخال كلمة مرور الأموال الصحيحة',
    fundPasswordPreRequired: 'يرجى إدخال تأكيد كلمة المرور الصحيحة',
    fundPasswordDiff: 'كلمتا المرور غير متطابقتين',
    bindSuccess: 'تم ربط كلمة مرور الأموال بنجاح',
    tips: 'كلمة مرور الأموال هي شهادة هامة للمعاملات، يرجى ضبطها بعناية وتذكرها'
  },
  editLoginPassword: {
    title: 'تغيير كلمة مرور الدخول',
    currentPasswordLabel: 'كلمة المرور الحالية',
    currentPasswordPlaceholder: 'يرجى إدخال كلمة المرور الحالية للدخول',
    newPasswordLabel: 'كلمة المرور الجديدة',
    newPasswordPlaceholder: 'يرجى إدخال كلمة المرور الجديدة للدخول',
    prePasswordLabel: 'تأكيد كلمة المرور',
    prePasswordPlaceholder: 'يرجى إدخال كلمة المرور الجديدة مرة أخرى',
    tips: 'كلمة مرور الدخول هي شهادة هامة للمصادقة، يرجى ضبطها بعناية وتذكرها',
    currentPasswordRequired: 'يرجى إدخال كلمة المرور الحالية للدخول',
    newPasswordRequired: 'يرجى إدخال كلمة المرور الجديدة للدخول',
    prePasswordRequired: 'يرجى إدخال كلمة المرور الجديدة مرة أخرى',
    prePasswordDiff: 'كلمتا المرور غير متطابقتين'
  },
  bindGoogleValidator: {
    title: 'ربط مدقق جوجل',
    qrCodeLabel: 'رمز الاستجابة السريعة',
    keyLabel: 'المفتاح',
    loginPasswordLabel: 'كلمة مرور الدخول',
    loginPasswordPlaceholder: 'يرجى إدخال كلمة مرور الدخول الخاصة بك',
    googleCodeLabel: 'رمز التحقق من جوجل',
    googleCodePlaceholder: 'يرجى إدخال رمز التحقق من جوجل المكون من 6 أرقام',
    tipsPart1: 'ابحث عن مدقق جوجل في متجر التطبيقات',
    tipsPart2:
      'استخدم مدقق جوجل لمسح رمز الاستجابة السريعة أعلاه، أو أدخل المفتاح يدويًا لإتمام الربط',
    tipsPart3:
      'أدخل رمز التحقق من جوجل المكون من 6 أرقام أعلاه، ثم انقر على تأكيد للإرسال',
    loginPasswordRequired: 'يرجى إدخال كلمة مرور الدخول',
    googleCodeRequired: 'يرجى إدخال رمز التحقق من جوجل المكون من 6 أرقام'
  },
  walletAddress: {
    title: 'عنوان المحفظة',
    add: '+ إضافة عنوان المحفظة',
    remark: 'ملاحظة',
    addButton: 'إضافة عنوان المحفظة',
    tips: 'إذا كنت ترغب في تعديل أو حذف معلومات العنوان، يرجى الاتصال بالدعم'
  },
  addWalletAddress: {
    title: 'إضافة عنوان المحفظة',
    vcChainNameIdLabel: 'نوع السلسلة',
    vcAccountLabel: 'عنوان المحفظة',
    vcAccountPlaceholder: 'يرجى إدخال عنوان المحفظة',
    remarkLabel: 'ملاحظة',
    remarkPlaceholder: 'يرجى إدخال محتوى الملاحظة',
    fundPasswordLabel: 'كلمة مرور الأموال',
    fundPasswordPlaceholder: 'يرجى إدخال كلمة مرور الأموال الخاصة بك',
    tips:
      'لا يمكن تعديل عنوان المحفظة بعد الإضافة، يرجى التحقق من صحة المعلومات',
    vcIdRequired: 'يرجى اختيار نوع العملة الصحيح',
    vcChainNameIdRequired: 'يرجى اختيار نوع السلسلة الصحيح',
    vcAccountRequired: 'يرجى إدخال عنوان المحفظة الصحيح',
    fundPwdRequired: 'يرجى إدخال كلمة مرور الأموال الصحيحة',
    addSuccess: 'تمت إضافة عنوان المحفظة بنجاح'
  },
  receiveWays: {
    title: 'بطاقاتي البنكية',
    add: '+ إضافة بطاقة بنكية',
    tips:
      'إذا كنت ترغب في تعديل أو حذف معلومات البطاقة البنكية، يرجى الاتصال بالدعم',
    addCardButton: 'إضافة بطاقة بنكية'
  },

  zskAccount: {
    title: 'حساب ZSK',
    add: '+ إضافة حساب ZSK',
    tips:
      'إذا كنت تريد تعديل أو حذف معلومات الحساب، يرجى الاتصال بخدمة العملاء',
    addCardButton: 'إضافة حساب'
  },
  addZskAccount: {
    title: 'إضافة حساب ZSK جديد',
    withdrawNameLabel: 'الاسم',
    withdrawNamePlaceholder: 'الرجاء إدخال الاسم',
    withdrawNameRequired: 'الاسم لا يمكن أن يكون فارغًا',
    zskLabel: 'ZSK',
    zskPlaceholder: 'الرجاء إدخال ZSK',
    fundPasswordLabel: 'كلمة مرور الأموال',
    fundPasswordPlaceholder: 'الرجاء إدخال كلمة مرور الأموال',
    tips:
      'يرجى توخي الحذر عند ملء معلومات إضافة الحساب، حيث أن الشركة ليست مسؤولة عن مشاكل السحب الناتجة عن الأخطاء في المعلومات المدخلة'
  },
  addBankCard: {
    title: 'إضافة بطاقة مصرفية جديدة',
    cardNumLabel: 'رقم البطاقة المصرفية',
    withdrawNameLabel: 'الاسم',
    withdrawNamePlaceholder: 'الرجاء إدخال الاسم',
    withdrawNameRequired: 'الاسم لا يمكن أن يكون فارغًا',
    zskLabel: 'ZSK',
    zskPlaceholder: 'الرجاء إدخال ZSK',
    zskRequired: 'الرجاء إدخال ZSK صحيح',
    cardNumPlaceholder: 'الرجاء إدخال رقم البطاقة المصرفية',
    branchLabel: 'عنوان الفرع',
    branchPlaceholder: 'الرجاء إدخال عنوان فرع البنك',
    fundPasswordLabel: 'كلمة مرور الأموال',
    fundPasswordPlaceholder: 'الرجاء إدخال كلمة مرور الأموال',
    tips:
      'البطاقة المصرفية هي معلومات هامة للمعاملات والسحب، يرجى توخي الحذر عند ملء المعلومات. الشركة ليست مسؤولة عن مشاكل السحب الناتجة عن الأخطاء في المعلومات المدخلة.',
    backIdRequired: 'الرجاء اختيار البنك',
    cardNumRequired: 'الرجاء إدخال رقم البطاقة المصرفية الصحيح',
    fundPwdRequired: 'الرجاء إدخال كلمة مرور الأموال الصحيحة',
    idCardPlaceholder: 'الرجاء إدخال رقم الهوية',
    idCardLabel: 'رقم الهوية',
    idCardRequired: 'الرجاء إدخال رقم الهوية الصحيح',
    cciPlaceholder: 'الرجاء إدخال CCI للبطاقة المصرفية',
    branchCodePlaceholder: 'الرجاء إدخال رمز الفرع',
    branchCodeLabel: 'رمز الفرع',
    katakanaPlaceholder: 'الرجاء إدخال Katakana',
    katakanaLabel: 'Katakana'
  },
  userBills: {
    title: 'سجلات الحساب',
    vcName: 'العملة',
    amount: 'المبلغ',
    balance: 'الرصيد'
  },
  timingTradeOrder: {
    title: 'أوامر التداول السريع',
    waiting: {
      title: 'الأوامر الحالية',
      amount: 'المبلغ',
      period: 'الفترة',
      receivePrice: 'سعر الشراء',
      settlement: 'جاري التسوية'
    },
    history: {
      title: 'الأوامر السابقة',
      buyInClose: 'سعر الشراء',
      saleOutClose: 'سعر البيع'
    }
  },
  spotTradeOrder: {
    title: 'أوامر تداول العقود',
    waiting: {
      title: 'الأوامر الحالية',
      buyInAmount: 'إجمالي سعر الشراء',
      buyInPrice: 'سعر الشراء لكل وحدة',
      buyInCount: 'عدد الشراء',
      buyInTime: 'وقت الشراء'
    },
    history: {
      title: 'الأوامر السابقة',
      buyInAmount: 'إجمالي سعر الشراء',
      buyInPrice: 'سعر الشراء لكل وحدة',
      buyInCount: 'عدد الشراء',
      sellOutAmount: 'إجمالي سعر البيع',
      sellOutPrice: 'سعر البيع لكل وحدة',
      sellOutTime: 'وقت البيع'
    }
  },
  userReport: {
    title: 'تقرير المستخدم',
    profit: 'الأرباح',
    timingTradeAmountFee: 'رسوم/طلب التداول السريع',
    timingTradePrizePoint: 'جائزة/نقاط تداول سريع',
    rechargeInfo: 'إيداع/رسوم',
    withdrawInfo: 'سحب/رسوم',
    exchangeInfo: 'تحويل/رسوم'
  },
  userReportDay: {
    title: 'تقرير المستخدم اليومي',
    profit: 'الأرباح',
    timingTradeAmountFee: 'رسوم/طلب التداول السريع',
    timingTradePrizePoint: 'جائزة/نقاط تداول سريع',
    rechargeInfo: 'إيداع/رسوم',
    withdrawInfo: 'سحب/رسوم',
    exchangeInfo: 'تحويل/رسوم'
  },
  teamReport: {
    title: 'تقرير الفريق',
    goToReportDay: 'عرض التقرير اليومي',
    timingTradeBetAmountServiceCharge: 'رسوم/طلب التداول السريع',
    timingTradeBetPrizePoint: 'جائزة/نقاط تداول سريع',
    timingTradeUserAndCount: 'عدد/أفراد تداول سريع',
    rechargeAmountFee: 'مبلغ/رسوم الإيداع',
    rechargePersonCount: 'عدد/أفراد الإيداع',
    withdrawAmountFee: 'مبلغ/رسوم السحب',
    withdrawPersonCount: 'عدد/أفراد السحب',
    firstRechargeUserAndCount: 'مبلغ/عدد الإيداع الأول',
    usernamePlaceholder: 'أدخل اسم المستخدم الفرعي',
    previewAllTradeInfo: 'عرض جميع معلومات التداول السريع',
    coin: 'العملة',
    timingTradeBetAmount: 'مبلغ رهان التداول السريع',
    profit: 'الأرباح',
    action: 'الإجراء',
    previewReportDay: 'عرض التقرير اليومي'
  },
  teamTimingTradeInfo: {
    title: 'معلومات التداول السريع للفريق',
    profit: 'الأرباح',
    subTitle: 'معلومات التداول السريع للفريق',
    timingTradeAmountFee: 'رسوم/طلب التداول السريع',
    timingTradePrizePoint: 'جائزة/نقاط تداول سريع',
    rechargeInfo: 'إيداع/رسوم',
    withdrawInfo: 'سحب/رسوم',
    exchangeInfo: 'تحويل/رسوم'
  },
  teamReportDay: {
    title: 'تقرير الفريق اليومي',
    subTitle: 'تقرير الفريق اليومي [ {username} ]',
    timingTradeBetAmountFee: 'رسوم/طلب التداول السريع',
    timingTradeBetPrizePoint: 'جائزة/نقاط تداول سريع',
    rechargeAmountFee: 'مبلغ/رسوم الإيداع',
    rechargePersonCount: 'عدد/أفراد الإيداع',
    timingTradeUserAndCount: 'عدد/أفراد تداول سريع',
    firstRechargePersonCount: 'مبلغ/عدد الإيداع الأول',
    withdrawAmountFee: 'مبلغ/رسوم السحب',
    withdrawPersonCount: 'عدد/أفراد السحب',
    exchangeAmountFee: 'مبلغ/رسوم التحويل'
  },
  share: {
    title: 'أريد المشاركة',
    qrCodeLabel: 'رمز الاستجابة السريعة',
    registerUrlLabel: 'رابط التسجيل',
    inviteCodeLabel: 'رمز الدعوة',
    hasNoInviteCode: 'الحساب الحالي ليس لديه رمز دعوة،',
    generateInvitationCode: 'حاول إنشاء رمز بدعوة بنقرة واحدة',
    tipsPart1:
      'مسح رمز الاستجابة السريعة أعلاه لملء معلومات التسجيل وإجراء التسجيل',
    tipsPart2: 'نسخ رابط التسجيل لملء معلومات التسجيل وإجراء التسجيل',
    tipsPart3:
      'افتح يدوياً واجهة التسجيل في هذا الموقع لملء رمز الدعوة وإجراء التسجيل',
    saveImageError: 'فشل حفظ الصورة، حاول الضغط على الصورة لفترة طويلة ثم حفظها'
  },
  myTeam: {
    title: 'فريقي',
    usernamePlaceholder: 'أدخل اسم المستخدم الفرعي',
    point: 'نقاط المكافأة (تداول سريع/عقود)',
    totalBalance: 'الرصيد الإجمالي',
    lastLoginTime: 'آخر تسجيل دخول',
    noLoginTime: 'لا يوجد'
  },

  userDetail: {
    username: 'اسم المستخدم',
    userType: 'نوع المستخدم',
    title: 'تفاصيل المستخدم',
    pointPercentTiming: 'نسبة استرداد التجارة السريعة',
    pointPercentContract: 'نسبة استرداد التجارة بالعقد',
    registerWay: 'طريقة التسجيل',
    teamCounts: 'عدد الفريق',
    teamOnline: 'الفريق على الإنترنت',
    balance: 'الرصيد',
    registerTime: 'وقت التسجيل',
    onlineStatus: 'حالة تسجيل الدخول'
  },
  addUser: {
    title: 'إضافة مستخدم',
    addUserDirect: {
      userTypeLabel: 'نوع المستخدم',
      usernameLabel: 'اسم المستخدم',
      usernamePlaceholder: 'الرجاء إدخال اسم مستخدم الحساب',
      pointTimingLabel: 'نسبة استرداد التجارة السريعة',
      pointContractLabel: 'نسبة استرداد التجارة بالعقد',
      tips:
        'كلمة المرور الافتراضية هي: "{password}"؛ يرجى تذكير المستخدم بتغيير كلمة المرور بعد التسجيل',
      userTypeRequired: 'الرجاء اختيار نوع الحساب',
      usernameRequired: 'الرجاء إدخال اسم مستخدم الحساب',
      pointTimingRequired: 'الرجاء اختيار نسبة استرداد التجارة السريعة',
      pointContractRequired: 'الرجاء اختيار نسبة استرداد التجارة بالعقد',
      copyTemplate:
        'اسم المستخدم: {username}; كلمة المرور: {loginPassword}; عنوان تسجيل الدخول: {loginAddress}; نسبة استرداد التجارة السريعة: {timingTradePoint}; نسبة استرداد التجارة بالعقد: {contactTradePoint};'
    }
  },
  recharge: {
    title: 'إعادة شحن',
    configIdLabel: 'قناة الشحن',
    chainNameLabel: 'اسم السلسلة',
    amountLabel: 'مبلغ الشحن',
    userCardNameLabel: 'اسم الدافع',
    userCardNamePlaceholder: 'الرجاء إدخال اسم الدافع',
    fee: 'رسوم الخدمة',
    receiveAmountTipsPart1: 'إعادة شحن',
    receiveAmountTipsPart2: '، تحتاج لدفع',
    tipsPart1:
      'بسبب عدم استقرار واجهة الدفع عبر الإنترنت، يتم دعم التحويل البنكي فقط حاليًا!',
    tipsPart2:
      'الرجاء إدخال مبلغ التحويل الفعلي بدقة لتجنب تأخير في عملية المراجعة.',
    emptyPart1: 'لا توجد قنوات شحن متاحة،',
    emptyPart2: 'انقر لإعادة المحاولة',
    amountRequired: 'مبلغ الشحن لا يمكن أن يكون فارغًا',
    maxPrecisionError: 'أقصى عدد للأرقام العشرية هو {amountMaxPrecision}',
    payUserNameError: 'الرجاء إدخال اسم دافع صحيح ثم حاول مرة أخرى',
    userMobileLabel: 'رقم الهاتف المحمول',
    userMobilePlaceholder: 'الرجاء إدخال رقم الهاتف المحمول',
    needPayLabel: 'مطلوب الدفع',
    needPayPlaceholder: 'انقر لإدخال المبلغ'
  },
  payDetail: {
    title: 'تفاصيل التحويل',
    addressLabel: 'عنوان الشحن',
    rechargeAmount: 'مبلغ الشحن',
    bankNameLabel: 'البنك',
    branchLabel: 'عنوان الفرع',
    cardName: 'الاسم',
    cardNum: 'رقم البطاقة',
    uploadImgLabel: 'إيصال الدفع',
    uploadImgPlaceholder: 'انقر لتحميل صورة إيصال الدفع',
    uploadImgRequired: 'الرجاء تحميل صورة إيصال الدفع',
    vcTransferTipsPart1: '1. انسخ عنوان الشحن أو امسح رمز QR لإجراء الشحن',
    vcTransferTipsPart2: '2. بعد الانتهاء من الشحن، قم بتحميل صورة إيصال الدفع',
    vcTransferTipsPart3:
      'لضمان كفاءة عملية الشحن، الرجاء تحميل صورة إيصال واضحة ودقيقة، عدم وضوح الصورة قد يؤدي إلى تأخير في عملية المراجعة.',
    bankCardTips:
      'لضمان كفاءة عملية الشحن، الرجاء استخدام اسم الدافع المطابق لاسم المحول، عدم تطابق المعلومات قد يؤدي إلى تأخير في عملية المراجعة.',
    bankCardTransferSuccess: 'لقد قمت بالتحويل بنجاح'
  },
  rechargeOrder: {
    title: 'طلب الشحن',
    payAmount: 'مبلغ الشحن',
    receiveAmount: 'المبلغ المستلم'
  },
  identity: {
    title: 'معلومات الهوية',
    subTitle: 'التوثيق يشمل التحقق من المعلومات، والتحقق من الهوية',
    name: 'الاسم',
    idType: 'نوع الوثيقة',
    idNum: 'رقم الوثيقة',
    demand: 'المتطلبات',
    informationVer: 'التحقق من المعلومات',
    idAuthentication: 'التحقق من الهوية',
    material: 'المواد'
  },
  verified: {
    title: 'توثيق الهوية',
    idCardTypeLabel: 'نوع الوثيقة',
    idCardFrontSideImgLabel: 'صورة الجهة الأمامية للوثيقة',
    idCardBackSideImgLabel: 'صورة الجهة الخلفية للوثيقة',
    idCardHandSideImgLabel: 'صورة مع الوثيقة باليد',
    nameLabel: 'اسم الوثيقة',
    namePlaceholder: 'الرجاء إدخال اسم الوثيقة',
    idCardNumLabel: 'رقم الوثيقة',
    idCardNumPlaceholder: 'الرجاء إدخال رقم الوثيقة',
    fundPwdLabel: 'كلمة مرور الصندوق',
    fundPwdPlaceholder: 'الرجاء إدخال كلمة مرور الصندوق',
    tips:
      'بمجرد تقديم المعلومات، لا يمكن تعديلها، الرجاء التحقق بدقة قبل الإدخال',
    idCardTypeRequired: 'الرجاء اختيار نوع الوثيقة',
    idCardFrontSideImgRequired: 'الرجاء تحميل صورة الجهة الأمامية للوثيقة',
    idCardBackSideImgRequired: 'الرجاء تحميل صورة الجهة الخلفية للوثيقة',
    idCardHandSideImgRequired: 'الرجاء تحميل صورة مع الوثيقة باليد',
    nameRequired: 'الرجاء إدخال اسم الوثيقة',
    idCardNumRequired: 'الرجاء إدخال رقم الوثيقة',
    fundPwdRequired: 'الرجاء إدخال كلمة مرور الصندوق',
    submitSuccess: 'تم تقديم طلب التوثيق بنجاح'
  },
  help: {
    title: 'مركز المساعدة'
  },
  helpDetail: {
    title: 'تفاصيل المساعدة'
  },
  myMessage: {
    title: 'رسائلي الخاصة'
  },
  messageDetail: {
    title: 'تفاصيل الرسالة الخاصة'
  },
  withdraw: {
    title: 'سحب',
    tips:
      'لضمان أمان الأموال وكفاءة السحب، الرجاء التحقق من صحة المعلومات المدخلة، سيتم خصم رسوم المعاملة من الرصيد',
    receiveAmountTipsPart1: 'سحب',
    receiveAmountTipsPart2: '، المبلغ المتوقع للوصول',
    fee: 'رسوم الخدمة',
    myBalance: 'رصيدي [{vcName}] :',
    configIdLabel: 'قناة السحب',
    amountLabel: 'مبلغ السحب',
    fundLabel: 'كلمة مرور الصندوق',
    fundPlaceholder: 'الرجاء إدخال كلمة مرور الصندوق',
    googleCodeLabel: 'رمز جوجل',
    googleCodePlaceholder: 'الرجاء إدخال رمز جوجل المكون من 6 أرقام',
    maxPrecisionError: 'أقصى عدد للأرقام العشرية هو {amountMaxPrecision}',
    amountRequired: 'الرجاء إدخال أو اختيار مبلغ السحب الصحيح',
    bankCardError: 'الرجاء اختيار بطاقة بنكية صحيحة',
    fundPwdError: 'الرجاء إدخال كلمة مرور الصندوق الصحيحة',
    walletAddressError: 'الرجاء اختيار عنوان محفظة صحيح',
    success: 'تم تقديم طلب السحب بنجاح، الرجاء الانتظار للمعالجة',
    emptyPart1: 'لا توجد قنوات سحب متاحة،',
    emptyPart2: 'انقر لإعادة المحاولة'
  },
  withdrawOrder: {
    title: 'طلب السحب',
    requestAmount: 'مبلغ الطلب',
    receiveAmount: 'المبلغ المستلم'
  },
  locales: {
    title: 'تغيير اللغة'
  },
  lines: {
    title: 'اختيار الخطوط',
    switchLine: 'تغيير الخطوط'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'تم حذف العملة المفضلة بنجاح',
    addFavoriteSuccess: 'تم إضافة العملة المفضلة بنجاح'
  },
  currencySelect: {
    currencyName: 'اسم العملة',
    currencyPlaceholder: 'انقر لاختيار العملة'
  },

  walletItem: {
    available: 'متاح',
    convert: 'يعادل (USDT)'
  },
  banks: {
    bankIdLabel: 'البنك',
    bankIdPlaceholder: 'انقر لاختيار البنك'
  },
  banksPop: {
    title: 'اختر البنك',
    search: 'أدخل كلمات مفتاحية للبنك'
  },
  historyOrderDetail: {
    title: 'تفاصيل الطلب',
    coin: 'العملة المتداولة',
    amount: 'مبلغ الطلب',
    buyInClose: 'سعر الشراء',
    sellOutClose: 'سعر البيع',
    isQuest: 'هل لديك استفسار بخصوص هذا الطلب؟',
    connectCustomer: 'اتصل بخدمة العملاء؟'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'انقر لاختيار معدل النقاط للمستخدم'
  },
  walletAddressSelect: {
    title: 'اختر عنوان المحفظة',
    label: 'عنوان المحفظة',
    placeholder: 'انقر لاختيار عنوان المحفظة'
  },
  myCardSelect: {
    title: 'اختر الحساب',
    label: 'حساب المستلم',
    placeholder: 'انقر لاختيار الحساب'
  },
  amountInput: {
    amountRange: 'الحد الأدنى {minAmount}، الحد الأقصى {maxAmount}',
    amountMin: 'الحد الأدنى {minAmount}، لا حد أقصى',
    amountErrorEmpty: 'هناك خطأ في {label}، يرجى التحقق والمحاولة مرة أخرى',
    amountErrorOutRange: '{label} خارج النطاق، يرجى التحقق والمحاولة مرة أخرى'
  },
  amountFormItem: {
    placeholderOnlyMin: 'الحد الأدنى {minAmount}، لا حد أقصى',
    placeholderHasMax: 'الحد الأدنى {minAmount}، الحد الأقصى {maxAmount}',
    amountErrorEmpty: 'هناك خطأ في المبلغ، يرجى التحقق والمحاولة مرة أخرى',
    amountErrorOutRange: 'المبلغ خارج النطاق، يرجى التحقق والمحاولة مرة أخرى'
  },
  common: {
    remark: 'ملاحظة',
    saveImage: 'حفظ محليًا',
    online: 'متصل',
    offline: 'غير متصل',
    profit: 'الأرباح والخسائر',
    date: 'التاريخ',
    period: 'الفترة',
    pointAmount: 'مبلغ نقاط المستخدم',
    point: 'نقاط المستخدم',
    direction: 'الاتجاه',
    winLoss: 'الربح والخسارة',
    lose: 'خسارة',
    add: 'إضافة',
    win: 'ربح',
    edit: 'تعديل',
    notBind: 'غير مرتبط',
    alreadyBind: 'مرتبط بالفعل',
    enabled: 'مفعل',
    notEnabled: 'غير مفعل',
    queryRange: 'نطاق البحث',
    copy: 'نسخ',
    orderNum: 'رقم الطلب',
    null: 'لا يوجد',
    noData: 'لا توجد بيانات',
    refreshSuccess: 'تم التحديث بنجاح',
    loadMoreData: 'تحميل المزيد من البيانات',
    noMoreData: 'لا توجد بيانات أخرى',
    lookMore: 'عرض المزيد',
    more: 'المزيد'
  },
  date: {
    today: 'اليوم',
    yesterday: 'أمس',
    last7Days: 'آخر 7 أيام',
    last14Days: 'آخر 14 أيام',
    split: 'إلى'
  },
  button: {
    save: 'حفظ',
    logout: 'تسجيل الخروج',
    confirm: 'تأكيد',
    cancel: 'إلغاء',
    submit: 'إرسال',
    addNow: 'أضف الآن',
    reset: 'إعادة تعيين',
    nextStep: 'الخطوة التالية',
    goCertification: 'الذهاب للتحقق'
  },
  confirm: {
    title: {
      logout: 'تسجيل الخروج',
      unBindFundPassword: 'لم يتم ربط كلمة المرور الخاصة بالأموال',
      addUserDirect: 'إضافة مستخدم جديد',
      addUserInfo: 'تم إضافة المستخدم بنجاح',
      jumpToRechargePage: 'تأكيد الانتقال',
      unAuthentication: 'لم يتم التحقق من الهوية',
      noBindBankCard: 'لم يتم إضافة بطاقة بنكية',
      noBindCoinAddress: 'لم يتم إضافة عنوان محفظة',
      tradeConfirm: 'تأكيد التداول',
      sellOutSpotOrder: 'بيع الأمر المحتفظ به',
      buyFinance: 'تأكيد الشراء',
      redeemOrder: 'استرداد الطلب'
    },
    content: {
      logout: 'هل أنت متأكد من أنك تريد تسجيل الخروج من الحساب الحالي؟',
      unBindFundPassword:
        'تم الكشف عن أن كلمة المرور الخاصة بالأموال لم يتم ربطها، لضمان أمان الحساب، يرجى ربط كلمة المرور الخاصة بك أولاً',
      addUserDirect:
        'سيتم إضافة مستخدم جديد، يرجى التحقق من صحة المعلومات المدخلة ثم النقر على تأكيد للاستمرار، اسم المستخدم [ {username} ]، نوع المستخدم [ {userType} ]، كلمة المرور [ {password} ]، الفرق في نسبة النقاط بين تداولاتي السريعة وتداولاتي بالعقود [ {diffPointTiming} ]، الفرق في نسبة النقاط بين تداولاتي بالعقود وتداولاتي بالعقود [ {diffPointContract} ]',
      addUserInfo:
        'اسم المستخدم [ {username} ]؛<br />كلمة المرور [ {password} ]؛<br />عنوان تسجيل الدخول [ {loginAddress} ]؛<br />نسبة النقاط في التداولات السريعة [ {pointPercentTiming} ]؛<br />نسبة النقاط في تداول العقود [ {pointPercentContract} ]؛',
      jumpToRechargePage:
        'سيتم الانتقال إلى واجهة الشحن الخارجية، يرجى النقر على تأكيد للاستمرار',
      unAuthentication:
        'تم الكشف عن أن الحساب لم يتم التحقق من الهوية، لضمان تدفق الأموال بشكل طبيعي، يرجى إجراء التحقق من الهوية أولاً',
      noBindBankCard:
        'تم الكشف عن أن الحساب لم يتم إضافة أو تفعيل بطاقة بنكية، لضمان تدفق الأموال بشكل طبيعي، يرجى إضافة بطاقة بنكية أولاً',
      noBindCoinAddress:
        'تم الكشف عن أن الحساب لم يتم إضافة أو تفعيل عنوان محفظة للعملات الرقمية، لضمان تدفق الأموال بشكل طبيعي، يرجى إضافة عنوان محفظة للعملات الرقمية أولاً',
      tradeConfirm:
        'سيتم تقديم الطلب، يرجى التحقق من صحة معلومات الطلب ثم النقر على تأكيد الطلب لتقديمه',
      sellOutSpotOrder:
        'سيتم بيع الأمر المحتفظ به، يرجى التأكد من صحة العملية ثم النقر على تأكيد للاستمرار',
      buyFinance:
        'سيتم شراء [{coin}]، الكمية المشتراة: {amount}، يرجى التأكد من صحة العملية ثم النقر على تأكيد للاستمرار',
      redeemOrder:
        'سيتم استرداد الطلب ({orderNum})، يرجى التأكد من صحة العملية ثم النقر على تأكيد للاستمرار'
    }
  },
  message: {
    bindSuccess: 'تم الربط بنجاح',
    successOperation: 'تمت العملية بنجاح',
    logoutSuccess: 'تم تسجيل الخروج بنجاح',
    editSuccess: 'تم التعديل بنجاح',
    addSuccess: 'تمت الإضافة بنجاح',
    copySuccess: 'تم النسخ بنجاح',
    copyFailed: 'فشل النسخ'
  },
  vux: {
    'inline-calendar': {
      week_day_0: 'الأحد',
      week_day_1: 'الاثنين',
      week_day_2: 'الثلاثاء',
      week_day_3: 'الأربعاء',
      week_day_4: 'الخميس',
      week_day_5: 'الجمعة',
      week_day_6: 'السبت'
    },
    loading: {
      loading: 'جارٍ التحميل'
    }
  },
  helpItems: {
    title: {
      part1: 'لماذا يحدث تغيير في قيمة الموجودات؟',
      part2: 'ماذا أفعل إذا نسيت كلمة مرور معاملات OTC؟',
      part3: 'أين تذهب الأموال بعد إكمال عملية شراء OTC؟',
      part4: 'لماذا يقتصر تعديل الاسم المستعار؟',
      part5: 'ماذا يعني التحويل؟ ولماذا هو مطلوب؟',
      part6: 'كيف يتم حساب حقوق حساب المستخدم في العقود؟',
      part7:
        'ما هو دور القيم المحددة لجني الأرباح ووقف الخسائر في العقود؟ وكيف يجب تحديدها؟',
      part8: 'كيف يمكن تقليل نسبة المخاطرة في العقود؟',
      part9: 'ماذا تعني الكمية في فتح العقود؟',
      part10: 'توضيح بشأن الإغلاق القسري',
      part11: 'ما هي قواعد تداول العقود؟',
      part12: 'ما هو الهامش في تداول العقود؟',
      part13: 'ما هو الطلب المحدد والسوقي؟',
      part14: 'ماذا تعني نسبة المخاطرة في العقود؟',
      part15: 'لماذا يجب القيام بتحويل العملات؟',
      part16: 'لماذا لم يستلم الطرف الآخر التحويل فوراً بعد معاملات OTC؟',
      part17: 'كيف تشتري Tether (USDT) من خلال OTC؟'
    },
    content: {
      part1:
        'قيمة الأصول المحسوبة هي قيمة العملات الرقمية التي تمتلكها محولة إلى العملة المحلية، وهي تتغير بسبب تقلبات أسعار الأصول الرقمية. كمية الأصول الرقمية الخاصة بك لم تتغير.',
      part2:
        "إذا نسيت كلمة مرور معاملات OTC، يرجى الذهاب إلى 'الإعدادات - إعداد كلمة مرور المعاملات' أو الاتصال بخدمة العملاء لإعادة تعيينها.",
      part3:
        'بعد إكمال طلب شراء OTC، ستدخل الأموال إلى حساب العملات الورقية. إذا كنت بحاجة إلى استخدام الأصول المشتراة في العقود أو التداول الآجل، يرجى الانتقال إلى وحدة التحويل.',
      part4: 'لحماية أمان معاملاتك، يقتصر تعديل الاسم المستعار على مرة واحدة.',
      part5:
        'لتأكيد استقلالية أموال حساباتك المختلفة والسيطرة على المخاطر، يتم تقسيم الحسابات إلى وحدات تداول مختلفة. التحويل يعني عملية تحويل الأصول بين هذه الحسابات.',
      part6:
        '<p>يتم حساب حقوق حساب العقود كالتالي:</p> <p>حقوق حساب العقود = هامش الصفقات المفتوحة + الأرباح والخسائر العائمة + المبلغ المتاح حاليًا في الحساب</p>',
      part7:
        'جني الأرباح ووقف الخسائر هما الحدين الأقصى للأرباح والخسائر التي تحددها، وسيتم إغلاق الصفقة تلقائيًا عند الوصول إلى هذه الحدود. يُستخدمان للتحكم في المخاطر عند شراء العقود. يُفضل تحديد حد جني الأرباح كالتالي: مقدار الربح × الكمية × الرافعة المالية. نوصي بتحديد حد وقف الخسارة بناءً على حالتك المالية الفعلية للتحكم في المخاطر بشكل مناسب.',
      part8:
        'يمكنك تقليل نسبة المخاطرة عن طريق تحويل الأصول المتاحة من الحسابات الأخرى إلى حساب العقود، أو عن طريق تقليل حجم الصفقات المفتوحة.',
      part9:
        'الكمية في فتح العقود تشير إلى كمية العملات التي ترغب في شرائها. على سبيل المثال، في صفحة فتح عقود BTC/USDT، إذا اخترت شراء طويل وأدخلت السعر 1000 USDT والكمية 10 BTC، فهذا يعني أنك ترغب في شراء 10 BTC بسعر 1000 USDT لكل منها.',
      part10:
        '<p>نسبة المخاطرة هي مقياس للمخاطر في حسابك. عندما تصل نسبة المخاطرة إلى 100%، يتم اعتبار حسابك مغلقًا بالقوة. نسبة المخاطرة = (هامش الصفقات المفتوحة / حقوق حساب العقود) × 100%. لمنع المستخدمين من التعرض لخسائر كبيرة، يتم ضبط نسبة المخاطرة المسموح بها في النظام. عند الوصول إلى هذه النسبة، سيتم إغلاق جميع الصفقات المفتوحة تلقائيًا. على سبيل المثال، إذا كانت النسبة المسموح بها 10%، فسيتم إغلاق جميع الصفقات عندما تصل نسبة المخاطرة إلى 90% أو أكثر.</p> <p>ملاحظة: إذا تم إغلاق الصفقات بالقوة بسبب تجاوز نسبة المخاطرة، سيتم إغلاق جميع الصفقات المفتوحة. لذلك، نوصيك بالتحكم في نسبة المخاطرة بشكل مناسب لتجنب الخسائر غير الضرورية.</p>',
      part11:
        '<p>أنواع الصفقات</p> <p>الصفقات تنقسم إلى فتح شراء طويل (شراء) وفتح بيع قصير (بيع):</p> <p>الشراء الطويل (التفاؤلي) يعني أنك تتوقع ارتفاع السعر، وترغب في شراء كمية معينة من العقود بالسعر المحدد أو بالسعر الحالي للسوق.</p> <p>البيع القصير (التشاؤمي) يعني أنك تتوقع انخفاض السعر، وترغب في بيع كمية معينة من العقود بالسعر المحدد أو بالسعر الحالي للسوق.</p> <p>طرق الطلب</p> <p>الطلب المحدد: تقوم بتحديد السعر والكمية التي ترغب في تداولها بنفسك.</p> <p>الطلب السوقي: تقوم بتحديد الكمية فقط، ويتم تنفيذ الصفقة بالسعر الحالي للسوق.</p> <p>الصفقات المفتوحة</p> <p>عند تنفيذ طلب فتح صفقة، يتم اعتباره صفقة مفتوحة.</p> <p>مسألة تسوية العقود</p> <p>عقود المنصة هي عقود دائمة، ولا يوجد وقت محدد للتسوية. طالما لم يتم الوصول إلى شروط إغلاق الصفقة بالقوة أو لم تقم بإغلاق الصفقة يدويًا، يمكنك الاحتفاظ بالصفقة بشكل دائم.</p> <p>الإغلاق القسري</p> <p>1: الوصول إلى حدود جني الأرباح أو وقف الخسائر المحددة، سيتم إغلاق الصفقة تلقائيًا.</p> <p>2: نسبة المخاطرة العالية، سيتم إغلاق الصفقة بالقوة من قبل النظام.</p>',
      part12:
        '<p>في تداول العقود، يقوم المستخدم بدفع مبلغ من المال بناءً على سعر العقد والكمية والرافعة المالية المطلوبة كضمان للصفقة. هذا المبلغ هو هامش العقد. كلما زاد حجم الهامش المستخدم في فتح الصفقات، زادت نسبة المخاطرة في الحساب.</p> <p>هامش = (سعر العقد × الكمية) / الرافعة المالية</p>',
      part13:
        'الطلب المحدد يعني تحديد السعر الذي ترغب في تداول العقد به، بينما الطلب السوقي يعني تنفيذ الصفقة بالسعر الحالي للسوق. في قواعد فتح الصفقات، يتم تنفيذ الطلب السوقي أولاً قبل الطلب المحدد. إذا اخترت الطلب المحدد، يرجى تحديد السعر بناءً على الحالة الحالية للسوق لتجنب الخسائر الناتجة عن الأسعار غير المناسبة.',
      part14:
        'نسبة المخاطرة هي مؤشر للمخاطر في حساب العقود الخاص بك. عندما تصل نسبة المخاطرة إلى 100%، يتم اعتبار الحساب مغلقًا بالقوة. نوصي بأن تكون حذرًا عند فتح الصفقات إذا كانت نسبة المخاطرة تجاوزت 50% لتجنب الخسائر الناتجة عن الإغلاق القسري. يمكنك تقليل نسبة المخاطرة عن طريق إضافة أموال متاحة إلى حساب العقود أو تقليل حجم الصفقات المفتوحة.',
      part15:
        'التحويل يسمح لك بتحويل أصولك بين العملات المختلفة لتسهيل التداول. يمكن تحويل QCC المكتسبة في حساب العقود إلى USDT للتداول. يمكن أيضًا تحويل USDT في الحسابات الأخرى إلى QCC للتداول.',
      part16:
        'تأكد أولاً من تطابق طريقة الدفع مع التفاصيل الموجودة في صفحة الطلب. ثم تحقق من أن طريقة الدفع فورية وليست مؤجلة. أخيرًا، اتصل بالبنك أو مقدم الخدمة المالية للتأكد من عدم وجود صيانة نظام أو أسباب أخرى للتأخير.',
      part17:
        '<p>الطريقة الأولى: اختر الطلبات التي ترغب في شرائها أو بيعها من قائمة شراء وبيع OTC.</p> <p>الطريقة الثانية: اضغط على زر النشر وقم بإنشاء طلب شراء أو بيع حسب الحاجة لإجراء التداول بسرعة. سيقوم النظام بمطابقة المستخدمين بسرعة.</p> <p>ملاحظة: إذا لم يتم دفع طلب الشراء خلال 15 دقيقة، سيتم إلغاؤه تلقائيًا. يرجى الدفع في الوقت المناسب. إذا تم إلغاء الطلبات أكثر من ثلاث مرات في اليوم، لن تتمكن من التداول مجددًا في نفس اليوم، وسيتم استعادة حقوق التداول في اليوم التالي.</p>'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/ar.js